
import { Pipe, PipeTransform } from '@angular/core';
import { Activity } from '@jms/model';
import { UiActivityUtility } from '../utilities';

@Pipe({
    name: 'activityKind',
    standalone: true
})

export class ActivityKindPipe implements PipeTransform {

    transform(value: Activity): any {
        return UiActivityUtility.getKindIcon(value);
    }
}


@Pipe({
    name: 'activityKindColor',
    standalone: true
})

export class ActivityKindColorPipe implements PipeTransform {

    transform(value: Activity): any {
        return UiActivityUtility.getKindColor(value);
    }
}